const normalizeVariableDefinitions = (variableDefinitions) =>
  Object.fromEntries(
    Object.entries(variableDefinitions).map(([varName, definition]) => {
      const {
        rule,
        output: outputModes = [],
        default_value: defaultValue = '',
        color_ending: colorVarEnding = '_color',
        opacity_ending: opacityVarEnding = '_color_opacity',
      } = definition;

      return [
        varName,
        {
          rule: rule || varName,
          outputModes,
          defaultValue,
          colorVarEnding,
          opacityVarEnding,
        },
      ];
    })
  );

export default normalizeVariableDefinitions;
